module.exports = __webpack_public_path__ + "static/media/placeholder.d2b2c596.jpg";